// extracted by mini-css-extract-plugin
export default {"profile":"geaXsz","message":"KwD9eW","avatar":"EnwBKr","arrow":"TQere8","menu":"vJqOux"};